export { default } from './MyLockedTasksList';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/MyLockedTasksList/index.js